import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ja7u3kw: FaireProductEntity = {
  token: "p_5ja7u3kw",
  type: "product",
  name: "Peridot Earrings Aquamarine Gold",
  brandToken: "b_753b7wy8",
  brandName: "Laalee Jewelry",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/48b83ca0491a0b7e82de0cb4fd0b7245f70ce37336ba219c2defbc48311fdb69/1531296419.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8b540adcbfad6762ed197bec8c48d0e4cba09eb83d3d5f041631b0e6f64421a3/1531296439.jpg",
  ],
  priceDollars: 16,
  description:
    "The peridot glass gems are 16k gold plated and measure approximately 13mm with 5mm at the thickest part. The aquamarine square blocks measure 9mm with 3mm thickness and are gold plated. The earwires are 14k gold filled.\nThe length of the earrings is approximately 1.5 inches.\nThese earrings are really dainty and pretty.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:29.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
